import { render, staticRenderFns } from "./BusinessAccountClients.vue?vue&type=template&id=be9560f4"
import script from "./BusinessAccountClients.vue?vue&type=script&lang=js"
export * from "./BusinessAccountClients.vue?vue&type=script&lang=js"
import style0 from "./BusinessAccountClients.vue?vue&type=style&index=0&id=be9560f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports